import React from 'react';

import { Stack, Text } from '@eluve/components';

export const TabEmptyState: React.FC<{
  title: string;
  description: string;
}> = ({ title, description }) => {
  return (
    <Stack gap={1} className="items-center justify-center py-24 text-center">
      <Text size="md" weight="semibold">
        {title}
      </Text>
      <Text color="tertiary" weight="regular">
        {description}
      </Text>
    </Stack>
  );
};
